import { render } from "./AppHeader.vue?vue&type=template&id=3f955458&scoped=true&ts=true"
import script from "./AppHeader.vue?vue&type=script&lang=ts"
export * from "./AppHeader.vue?vue&type=script&lang=ts"

import "./AppHeader.vue?vue&type=style&index=0&id=3f955458&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/hph-sitecore-sites/hph-sitecore-sites/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f955458"]])

export default __exports__